const isPDP = document.querySelector('form[action="/cart/add"]') && document.querySelector('[data-block-type="variant-picker"]');
const upsellParent = document.querySelector('.upsell-section');
if (upsellParent) {
    const toggleUpsellVisibility = () => {
        const hasChild = upsellParent.querySelector('.hydrated');
        upsellParent.style.display = hasChild ? '' : 'none';
    };
    toggleUpsellVisibility();
    const upsellObserver = new MutationObserver(toggleUpsellVisibility);
    upsellObserver.observe(upsellParent, {
        childList: true,
        subtree: true,
    });
}
if (isPDP) {
    // const spinner = document.getElementById("shopify-spinner");
    // if (spinner){
    //   document.addEventListener("submit", function (e) {
    //     if (!e.target.matches('form[action="/cart/add"]')) return;
    //     spinner.hidden = false;
    //   });
    //   window.addEventListener("pageshow", function () {
    //     spinner.hidden = true;
    //   });
    //   const observer_btn = new MutationObserver(() => {
    //     const buybuttons = document.querySelector('.buy-buttons');
    //     if (buybuttons && buybuttons.querySelector(".banner--error")) {
    //       spinner.hidden = true;
    //     }
    //   });
    //   const observer = new MutationObserver(() => {
    //     spinner.hidden = true;
    //   });
    //   observer.observe(document.getElementById('cart-drawer'), {
    //     childList: true,
    //     subtree: true,
    //     attributes: true
    //   });
    //   observer_btn.observe(document.querySelector('.buy-buttons'), {
    //     childList: true,
    //     subtree: true,
    //     attributes: true
    //   });
    // }
    function getSelectedVariantValue(form) {
        const options = form.querySelectorAll('input.custom-variant-picker:checked');
        return Array.from(options).map(o => o.value.trim()).join(' / ');
    }

    document.querySelectorAll('.custom-variant-picker').forEach(input => {
        input.addEventListener('change', function() {
            if (!this.checked) return;

            const defaultSale = document.querySelector('.variant-based-sale-price');
            const defaultSaleNew = document.querySelector('.custom-variant-based-sale-price-new');
            const defaultSaleNew1 = document.querySelector('.custom-variant-based-sale-price-new1');
            const defaultCompare = document.querySelector('.variant-based-compare-price');
            const defaultComparenew = document.querySelector('.custom-new-variant-based-compare-price');            

            if (defaultSaleNew1 && defaultSaleNew1.classList.contains('remove-duplicate-span')) {
                const saleSpans = defaultSaleNew1.querySelectorAll('span');
                if (saleSpans.length > 1) saleSpans[1].style.display = "none";
            }
            if (defaultSaleNew && defaultSaleNew.classList.contains('remove-duplicate-span')) {
                const saleSpans = defaultSaleNew.querySelectorAll('span');
                if (saleSpans.length > 1) saleSpans[1].style.display = "none";
            }
            if (defaultSale && defaultSale.classList.contains('remove-duplicate-span')) {
                const saleSpans = defaultSale.querySelectorAll('span');
                if (saleSpans.length > 1) saleSpans[1].style.display = "none";
            }
            if (defaultCompare && defaultCompare.classList.contains('remove-duplicate-span')) {
                const compareSpans = defaultCompare.querySelectorAll('span');
                if (compareSpans.length > 1) compareSpans[1].style.display = "none";
            }
              if (defaultComparenew && defaultComparenew.classList.contains('remove-duplicate-span')) {
                const compareSpans = defaultComparenew.querySelectorAll('span');
                if (compareSpans.length > 1) compareSpans[1].style.display = "none";
            }
            const form = this.closest('variant-picker') || document;
            const selectedValue = getSelectedVariantValue(form);

            const allVariantSales = document.querySelectorAll('.custom-variant-based-sale-price');
            const allVariantCompares = document.querySelectorAll('.custom-variant-based-compare-price');

            let foundSale = false;
            let foundCompare = false;

            allVariantSales.forEach(sale => {
                const salePriceSpan = sale.querySelector('[data-sale-price]');
                const salePriceValid = salePriceSpan && salePriceSpan.dataset.salePrice && salePriceSpan.dataset.salePrice !== "null";

                if (sale.dataset.variantValue.trim() === selectedValue && salePriceValid) {
                    sale.style.display = 'inline-block';
                    foundSale = true;
                    if (defaultSale) defaultSale.style.display = 'none';
                    if (defaultSaleNew) defaultSaleNew.style.display = 'none';
                    if (defaultSaleNew1) defaultSaleNew1.style.display = 'none';
                } else {
                    sale.style.display = 'none';
                }
            });

            if (!foundSale && defaultSale) {
                defaultSale.style.display = 'inline-block'; // default fallback
            }
            if (!foundSale && defaultSaleNew) {
                defaultSaleNew.style.display = 'inline-block';
            }
            if (!foundSale && defaultSaleNew1) {
                defaultSaleNew1.style.display = 'inline-block';
            }
            allVariantCompares.forEach(compare => {
                if (compare.dataset.variantValue.trim() === selectedValue) {
                    compare.style.display = 'inline-block';
                    foundCompare = true;

                    const moneySpans = compare.querySelectorAll('.money');
                    if (moneySpans.length > 0) {
                        const lastSpan = moneySpans[moneySpans.length - 1];
                        if (lastSpan.dataset.price === "1") lastSpan.style.display = "none";
                    }

                } else {
                    compare.style.display = 'none';
                }
            });

            if (!foundCompare && defaultCompare) defaultCompare.style.display = 'inline-block';
        });
    });

    function formatMoney(cents, format = "") {
        if (typeof cents === "string") {
            cents = cents.replace(".", "");
        }
        const placeholderRegex = /\{\{\s*(\w+)\s*\}\}/,
            formatString = format || window.themeVariables.settings.moneyFormat;

        function defaultTo(value2, defaultValue) {
            return value2 == null || value2 !== value2 ? defaultValue : value2;
        }

        function formatWithDelimiters(number, precision, thousands, decimal) {
            precision = defaultTo(precision, 2);
            thousands = defaultTo(thousands, ",");
            decimal = defaultTo(decimal, ".");
            if (isNaN(number) || number == null) {
                return 0;
            }
            number = (number / 100).toFixed(precision);
            let parts = number.split("."),
                dollarsAmount = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, "$1" + thousands),
                centsAmount = parts[1] ? decimal + parts[1] : "";
            return dollarsAmount + centsAmount;
        }
        let value = "";
        switch (formatString.match(placeholderRegex)[1]) {
            case "amount":
                value = formatWithDelimiters(cents, 2);
                break;
            case "amount_no_decimals":
                value = formatWithDelimiters(cents, 0);
                break;
            case "amount_with_space_separator":
                value = formatWithDelimiters(cents, 2, " ", ".");
                break;
            case "amount_with_comma_separator":
                value = formatWithDelimiters(cents, 2, ".", ",");
                break;
            case "amount_with_apostrophe_separator":
                value = formatWithDelimiters(cents, 2, "'", ".");
                break;
            case "amount_no_decimals_with_comma_separator":
                value = formatWithDelimiters(cents, 0, ".", ",");
                break;
            case "amount_no_decimals_with_space_separator":
                value = formatWithDelimiters(cents, 0, " ");
                break;
            case "amount_no_decimals_with_apostrophe_separator":
                value = formatWithDelimiters(cents, 0, "'");
                break;
        }
        if (formatString.indexOf("with_comma_separator") !== -1) {
            return formatString.replace(placeholderRegex, value);
        } else {
            return formatString.replace(placeholderRegex, value);
        }
    }
    const defaultobserver = document.querySelector('.custom-variant-based-sale-price-new');
    const subscriptionExists = document.querySelector('.toggle-option.has-discount');
    let floatingTimeout;
    if (defaultobserver) {
        const observer = new MutationObserver(() => {
            const defaultSaleNew2 = document.querySelector('.custom-variant-based-sale-price-new');
            if (!defaultSaleNew2) return;
            let salePriceEl;
            if (defaultSaleNew2.classList.contains('remove-default-price')) {
                const salePrice = [...document.querySelectorAll('.custom-variant-based-sale-tag-price')]
                    .find(el => getComputedStyle(el).display !== 'none');
                if (salePrice) {
                    salePriceEl = salePrice.querySelector('span.money')
                } else {
                    salePriceEl = [...defaultSaleNew2.querySelectorAll('[data-price]')]
                        .reverse()
                        .find(el => getComputedStyle(el).display !== 'none');
                }
                if (!salePriceEl) return;
            } else {
                salePriceEl = [...defaultSaleNew2.querySelectorAll('[data-price]')]
                    .reverse()
                    .find(el => getComputedStyle(el).display !== 'none');
                if (!salePriceEl) return;
            }
            const originalPrice = parseFloat(salePriceEl.dataset.price);
            if (subscriptionExists) {
                const salePriceE2 = document.querySelector('[data-discount-multiplier]');
                if (!salePriceE2) return;


                const multiplier = parseFloat(salePriceE2.dataset.discountMultiplier);
                if (isNaN(originalPrice) || isNaN(multiplier)) return;

                let discountedPrice = Math.round(originalPrice * multiplier);
                discountedPrice = discountedPrice.toFixed(2);
                const moneyEl = salePriceE2.querySelector('.price-text.money');
                if (!moneyEl) return;
                moneyEl.innerHTML = formatMoney(discountedPrice);
                const floatingElement1 = document.getElementById('floating-price-id');
                const floatingElement = floatingElement1.querySelector('.floating-price');
                const floatingsaveElement = floatingElement1.querySelector('.pillComparison-price');
                floatingElement.innerHTML = `<span class="float-price-en">${formatMoney(originalPrice.toFixed(2))}</span>`;
                floatingsaveElement.innerHTML = formatMoney(discountedPrice);
                const variantPicker = document.querySelector('[data-block-type="variant-picker"]');
                const rect = variantPicker.getBoundingClientRect();
                const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
                if (isVisible) {
                    floatingElement1.classList.add('active');
                    positionFloatingNearVariantPicker();
                }
            } else {
                const floatingElement1 = document.getElementById('floating-price-id');
                const floatingElement = floatingElement1.querySelector('.floating-price');
                const floatingsaveElement = document.getElementById('pillComparison');
                floatingElement.innerHTML = `<span class="float-price-en">${formatMoney(originalPrice.toFixed(2))}</span>`;
                floatingsaveElement.style.display = 'none';
                const variantPicker = document.querySelector('[data-block-type="variant-picker"]');
                const rect = variantPicker.getBoundingClientRect();
                const isVisible = rect.top < window.innerHeight && rect.bottom > 0;
                if (isVisible) {
                    floatingElement1.classList.add('active');
                    positionFloatingNearVariantPicker();
                }
            }
        });
        observer.observe(
            document.querySelector('.custom-variant-based-sale-price-new'), {
                childList: true,
                subtree: true
            }
        );
    }
    window.addEventListener('scroll', () => {
        const floating = document.getElementById('floating-price-id');
        if (floating?.classList.contains('active')) {
            positionFloatingNearVariantPicker();
        }
    });

    window.addEventListener('resize', positionFloatingNearVariantPicker);

    function positionFloatingNearVariantPicker() {
        const floating = document.getElementById('floating-price-id');
        const picker = document.querySelector('[data-block-type="variant-picker"], .variant-picker');

        if (!floating || !picker) return;
        const pickerRect = picker.getBoundingClientRect();
        const floatingRect = floating.getBoundingClientRect();
        const header = document.querySelector('header, .site-header, .sticky-header');
        const announcement = document.querySelector(
            '.announcement-bar, .top-announcement, .site-announcement'
        );
        const headerHeight = header?.offsetHeight || 0;
        const announcementHeight = announcement?.offsetHeight || 0;
        const topOffset = headerHeight + announcementHeight;
        floating.style.top = `${topOffset}px`;
        floating.style.width = '100%';
    }
    const floatingWrapper = document.getElementById('floating-price-id');
    const variantPicker = document.querySelector('.variant-picker');
    if (floatingWrapper && variantPicker) {
        // let floatingTimeout1;
        const pickerObserver = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) {
                    const len = floatingWrapper.querySelector('.float-price-en');
                    if (!len) return;
                    floatingWrapper.classList.add('active');
                    positionFloatingNearVariantPicker();
                    // clearTimeout(floatingTimeout);
                    // floatingTimeout = setTimeout(() => {
                    //   floatingWrapper.classList.remove('active');
                    // }, 3000);
                } else {
                    floatingWrapper.classList.remove('active');
                }
            }, {
                threshold: 0.3
            }
        );
        pickerObserver.observe(variantPicker);
    }
    document.addEventListener('submit', async function(e) {
        const form = e.target;
        if (!form.matches('form[action="/cart/add"]')) return;

        const isSubscription = document.querySelector('#subscribe2')?.checked;

        if (!isSubscription) return;

        const variantId = Number(document.querySelector('#subscribe_product_id')?.value);
        async function getCart() {
            const res = await fetch('/cart.js');
            return res.json();
        }

        function subscriptionExists(cart, variantId) {
            return cart.items.some(item =>
                item.variant_id === variantId &&
                item.properties?._subscription === 'true'
            );
        }
        
        e.preventDefault();
        const cart = await getCart();
        if (subscriptionExists(cart, variantId)) {
            alert('This subscription product is already in your cart.');
            return;
        }
        document.documentElement.dispatchEvent(
            new CustomEvent('theme:loading:start', {
                bubbles: true
            })
        );
        await fetch('/cart/add.js', {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json'
            },
            body: JSON.stringify({
                items: [{
                    id: variantId,
                    quantity: 1,
                    properties: {
                        _subscription: 'true'
                    }
                }]
            })
        });
        document.documentElement.dispatchEvent(
            new CustomEvent('cart:refresh', {
                bubbles: true
            })
        );
        document.documentElement.dispatchEvent(
            new CustomEvent('theme:loading:end', {
                bubbles: true
            })
        );
        document.dispatchEvent(new CustomEvent('cart:open'));
    });

    function inchToCm(value) {
        return (value * 2.54).toFixed(1);
    }

    function cmToInch(value) {
        return (value / 2.54).toFixed(1);
    }

    function toggleUnit(unit, values, headings, activeUnit) {
        currentUnit = unit;
        document.querySelectorAll('.unit-btn').forEach(btn =>
            btn.classList.remove('active')
        );
        event?.target?.classList.add('active');
        const sizeSpecs = document.querySelector(
            ".selected-measurement-box .size-specs"
        );
        const unitToggle = document.querySelector('.unit-toggle');
        if (unit === 'cm') {
            unitToggle.classList.add('cm-active');
        } else {
            unitToggle.classList.remove('cm-active');
        }
        if (!sizeSpecs) return;
        const convertedSpecs = headings.slice(1).map((heading, index) => {
            let value = parseFloat(values[index + 1]);
            if (isNaN(value)) return `${heading}: -`;
            let convertedValue = value;
            if (unit === 'inches' && activeUnit === 'cm') {
                convertedValue = cmToInch(value);
            }
            if (unit === 'cm' && activeUnit === 'inches') {
                convertedValue = inchToCm(value);
            }
            return `${heading}: ${convertedValue}"`;
        });
        sizeSpecs.textContent = convertedSpecs.join(" | ");
    }

    function getSelectedSize() {
        const blockoption = document.querySelector(".block-swatch-option.select-size");
        let size = "";
        if (blockoption) {
            const checkedInput = blockoption.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
            if (checkedInput) {
                size = checkedInput.value.split("|")[0].trim().toLowerCase();
            }
        } else {
            size = document.querySelector(".product-form__input--dropdown.select-size span")?.innerText?.split('|')[0]?.trim();
        }
        return size ? size : "";
    }

    function getSelectedmeasurements() {
        const blockoptionz = document.querySelector(".block-swatch-option.select-size");
        const checkedInput = blockoptionz.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
        let staticmeasurements;
        if (checkedInput) {
            staticmeasurements = checkedInput.value.split("|")[1]?.trim()?.toLowerCase();
        }
        if (staticmeasurements == 'standard') return staticmeasurements;
        if (staticmeasurements == 'floor length') return 'standard';
        const blockoption = document.querySelector(".block-swatch-option.select-measurements");
        let measurements;
        if (blockoption) {
            const checkedInput = blockoption.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked');
            if (checkedInput) {
                measurements = checkedInput.value.split("|")[0].trim().toLowerCase();
            }
        } else {
            measurements = document.querySelector(".product-form__input--dropdown.select-measurements span")?.innerText.split('|')[0].trim().toLowerCase();
        }
        return measurements ? measurements : "standard";
    }

    function normalize(str) {
        return str.replace(/\u00A0/g, ' ').replace(/\s+/g, ' ').trim();
    }

    function findRow(size, measurements) {
        let tables = document.querySelectorAll(".ilmsc-table.first_column tbody");
        let result = null;
        if (measurements == 'made to measure') {
            tables = tables[1];
        } else {
            tables = tables[0]
        }
        tables.querySelectorAll("tr").forEach(row => {
            let firstCell = row.querySelector("td");
            if (firstCell) {
                let cellText = normalize(firstCell.innerHTML);
                let sizeText = normalize(size);
                if (cellText.toLowerCase() === sizeText.toLowerCase()) {
                    result = row;
                }
            }
        });
        const rows = tables.querySelectorAll("tr");
        const firstRow = rows.length > 0 ? rows[0] : null;
        return {
            result,
            firstRow
        };
    }

    function clearRowHighlights() {
        document.querySelectorAll(".ilmsc-table tr").forEach(row => {
            row?.classList?.remove("highlight-row");
        });
    }

    function displayMeasurement(size, measurements) {
        const sizenew = size?.replace(/\s+/g, '');
        const {
            result,
            firstRow
        } = findRow(sizenew, measurements);
        if (!result || !firstRow) {
            document.querySelector(".selected-measurement-box").innerHTML =
                `<p>No measurement found for size: ${size}</p>`;
            return;
        }
        clearRowHighlights();
        result.classList.add("highlight-row");
        const headings = Array.from(firstRow.querySelectorAll("th")).map(th =>
            normalize(th.textContent)
        );
        const values = Array.from(result.querySelectorAll("td")).map(td =>
            normalize(td.textContent)
        );
        const specsHTML = headings
            .slice(1)
            .map((heading, i, arr) => {
                const separator = i < arr.length - 1 ? ' | ' : '';
                return `<span>${heading}: ${values[i + 1]}${separator}</span>`;
            })
            .join('');
        const checkedOption = document.querySelector('.ilmsc-measurement .sb_variant_option:checked')?.id.toLowerCase() || 'inches';
        document.querySelector(".selected-measurement-box").innerHTML = `
      <div class="size-details">
        <span class="size-label">${values[0]} | ${measurements.toUpperCase()}</span>
        <span class="size-specs">${specsHTML}</span>
      </div>`
        document.querySelector(".measurement-box-size-import-place").innerHTML = `
      <div class="unit-toggle">
        <button class="unit-btn ${checkedOption === 'inches' ? 'active' : ''}"
          onclick='toggleUnit(
            "inches",
            ${JSON.stringify(values)},
            ${JSON.stringify(headings)},
            "${checkedOption}"
          )'>
          IN
        </button>
        <button class="unit-btn ${checkedOption === 'cm' ? 'active' : ''}"
          onclick='toggleUnit(
            "cm",
            ${JSON.stringify(values)},
            ${JSON.stringify(headings)},
            "${checkedOption}"
          )'>
          CM
        </button>
      </div>
    `;
    }
    document.addEventListener("click", function(e) {
        let tables = document.querySelectorAll(".ilmsc-table.first_column tbody");
        if (!tables || tables.length === 0) {
            document.getElementById("measurement_section").style.display = 'none';
            return;
        } else {
            document.getElementById("measurement_section").style.display = 'block';
        }
        const option = e.target.closest("[role='option']");
        let measurements = '';
        if (option) {
            const isSize = option?.classList?.contains("option-select-size");
            const isMeasurement = option?.classList?.contains("option-select-measurements");
            if (isSize || isMeasurement) {
                const size = getSelectedSize();
                measurements = getSelectedmeasurements();
                if (size && measurements) displayMeasurement(size, measurements);
            }
        }
        const option1 = e.target.closest(".block-swatch");
        if (option1) {
            const isSize =
                option1.nextElementSibling?.classList.contains("custom-variant-picker") ||
                option1.previousElementSibling?.classList.contains("custom-variant-picker");
            if (isSize) {
                let size = option1.previousElementSibling.value.toLowerCase();
                if (size == 'made to measure' || size == 'standard') {
                    measurements = size;
                    size = getSelectedSize()?.toLowerCase() || "";
                } else if (size == 'without booties' || size == 'with booties' || size == 'with detachable train' || size == 'without detachable train' || size == 'calf length' || size == 'full length' || size == 'with train' || size == 'without train' || size == 'white' || size == 'off - white') {
                    size = getSelectedSize()?.toLowerCase() || "";
                    measurements = getSelectedmeasurements();
                } else {
                    measurements = getSelectedmeasurements();
                    size = size.split("|")[0].trim().toLowerCase();
                }
                if (size && measurements) displayMeasurement(size, measurements);
            }
        }
    });
    setTimeout(() => {
        let tables = document.querySelectorAll(".ilmsc-table.first_column tbody");
        if (!tables || tables.length === 0) {
            document.getElementById("measurement_section").style.display = 'none';
            return;
        }
        let size = getSelectedSize()?.toLowerCase() || "";
        const measurements = getSelectedmeasurements();
        if (size && measurements) displayMeasurement(size, measurements);
        const blockoption = document.querySelector(".block-swatch-option.select-measurements");
        if (blockoption) {
            const checkedInput = blockoption.querySelector('input[type="radio"]:checked, input[type="checkbox"]:checked').nextElementSibling;
            if (checkedInput) handleOptionInfo(checkedInput);
        }
        updateTrigger();
    }, 200);

    function getTriggerElement() {
        if (window.innerWidth > 768) {
            return document.querySelector(".shopify-product-form");
        }
        return document.querySelector(".product-gallery .product-gallery__image-list");
    }
    let productForm = null;
    let formBottom = 0;

    function updateTrigger() {
        productForm = getTriggerElement();
        if (!productForm) {
            formBottom = 0;
            return;
        }
        const rect = productForm.getBoundingClientRect();
        formBottom = rect.top + window.scrollY + rect.height;
    }
    window.addEventListener("resize", updateTrigger);
    window.addEventListener("scroll", () => {
        const buyBtns = document.querySelector(".buynowbtns");
        if (!buyBtns) return;
        if (!formBottom) return;
        if (window.scrollY > formBottom) {
            buyBtns.classList.add("sticky");
        } else {
            buyBtns.classList.remove("sticky");
        }
    });
    document.addEventListener("change", function(e) {
        if (!e.target.matches("#help-in-size-fit-new")) return;
        const checkbox = e.target;
        const hidden = document.getElementById("help-in-size-fit-hidden");
        if (checkbox.checked) {
            hidden.value = "Yes";
            checkbox.value = "Yes";
        } else {
            hidden.value = "No";
            checkbox.value = "No";
        }
    });

    function handleOptionInfo(option) {
        if (!option) return;
        const info = option.dataset.optionInfoDetails?.trim();
        if (!info) return;
        const optionValues = option.closest('.variant-picker__option-values');
        if (!optionValues) return;
        const existing = optionValues.parentNode.querySelector('.variant-option-info');
        if (existing) existing.remove();
        const infoEl = document.createElement('div');
        infoEl.className = 'variant-option-info';
        infoEl.innerHTML = info;
        optionValues.parentNode.insertBefore(infoEl, optionValues);
    }
    document.addEventListener('click', function(e) {
        const option = e.target.closest('[data-option-info-details]');
        if (!option) return;
        handleOptionInfo(option);
    });
    document.addEventListener('click', function(e) {
        const tab = e.target.closest('.shipping-tab');
        if (!tab) return;
        const targetId = tab.dataset.tab;
        document.querySelectorAll('.shipping-tab').forEach(btn =>
            btn.classList.remove('active')
        );
        document.querySelectorAll('.shipping-tab-content').forEach(content =>
            content.classList.remove('active')
        );
        tab.classList.add('active');
        document.getElementById(targetId)?.classList.add('active');
    });

    document.addEventListener('modal:open', function(e) {
        if (e.target.id !== 'shipping_price_model') return;
        const firstTab = e.target.querySelector('.shipping-tab');
        const firstContent = e.target.querySelector('.shipping-tab-content');
        if (firstTab && firstContent) {
            e.target.querySelectorAll('.shipping-tab').forEach(t => t.classList.remove('active'));
            e.target.querySelectorAll('.shipping-tab-content').forEach(c => c.classList.remove('active'));
            firstTab.classList.add('active');
            firstContent.classList.add('active');
        }
    });
}